import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import './waba-failure.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaFailureProps {
  onBackClick: () => void;
}

export const WabaFailure: React.FC<WabaFailureProps> = ({ onBackClick }) => {
  // useWabaLoader();

  const renderIcons = () => {
    return (
      <div className="waba-failure-icons" style={{ marginTop: '80px' }}>
        <img src={SVGS.MetaIcon} alt="meta-icon" />
        <img src={SVGS.RefreshIcon} alt="refresh-icon" />
        <img src={SVGS.ZotokLogo} alt="zotok-apps-logo" />
      </div>
    );
  };

  const renderLoader = () => {
    return (
      <div className="waba-failure-loader-container">
        <img
          style={{ width: '100px', height: '100px' }}
          src={PNGS.WarningIcon}
          alt="waba-failure"
        />
      </div>
    );
  };
  return (
    <div
      // style={{  }}
      className="waba-failure primary-font-regular"
    >
      {renderIcons()}
      {renderLoader()}

      <div
        style={{
          marginBottom: '36px',
          marginRight: '48px',
          marginLeft: '48px',
          textAlign: 'center',
          width: 'auto',
        }}
        className="waba-failure-message font-14-regular-primary"
      >
        <div
          style={{ marginBottom: '10px' }}
          className="waba-failure-status-text font-16-bold-tertiary"
        >
          WABA Linking Failed / Cancelled
        </div>
        Please go back and try again or contact support.
      </div>

      <div className="waba-failure-footer">
        <ZoButton
          onClick={() => onBackClick()}
          label={'Back'}
          startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
          className="waba-failure-footer-back"
        />
        {/* <ZoButton
          isLoading={false}
          onClick={() => {}}
          label={'Launch Embedded Signup'}
          className="waba-failure-footer-continue"
        /> */}
      </div>
    </div>
  );
};
